import { render, staticRenderFns } from "./DoctorVerifyPage.vue?vue&type=template&id=4e547673&scoped=true"
import script from "./DoctorVerifyPage.vue?vue&type=script&lang=js"
export * from "./DoctorVerifyPage.vue?vue&type=script&lang=js"
import style0 from "./DoctorVerifyPage.vue?vue&type=style&index=0&id=4e547673&prod&scoped=true&lang=css"
import style1 from "./DoctorVerifyPage.vue?vue&type=style&index=1&id=4e547673&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e547673",
  null
  
)

export default component.exports